import styled from "@emotion/styled";
import { UnsetButton } from ".";

export const HighlightButton = styled(UnsetButton)<{
  isSaved: boolean;
  colour?: string;
}>`
  ${({ isSaved }) => isSaved && "border: 1px solid rgba(29, 30, 36, 1);"}
  box-shadow:
  1px 2px 4px rgba(32, 42, 91, 0.2),
  -2px -2px 4px rgba(253, 253, 251, 0.5);
  opacity: 1;
  background-color: ${({ colour, theme }) =>
    colour || theme.colours.highlight.yellow};
  border-radius: 50%;
  height: 26px;
  width: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
